import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const TextareaWrapper = styled.div`
  position: relative;
  width: 90%;
`;

export const Textarea = styled.textarea`
  border: 1px solid #d6d9e0;
  border-radius: 8px;
  padding: 1em;
  font-family: "Euclid Circular B";
  width: 100%;
  min-height: 100px;
  font-size: 16px;
  color: #040222;
  resize: vertical;
  outline: none;
  :focus {
    border: 1px solid #4f34d2;
  }
`;

export const ErrorText = styled(Text)`
  color: #d83d37;
  font-size: 12px;
  margin-top: 0.25em;
`;